
document.addEventListener('DOMContentLoaded', function () {


  // ----------------------------Home banner splide code---------------------------
  if (typeof Splide === 'undefined') return;
  const heroSlider = document.querySelector('#heroSplide');
  if (!heroSlider) return;
  const heroSplide = new Splide(heroSlider, {
    // Fade avoids Splide's cloned, eagerly loaded hero images.
    type: 'fade',
    rewind: true,
    perPage: 1,
    arrows: true,
    pagination: false,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
  }).mount();

  // The hero image can finish decoding after Splide's initial measurement,
  // especially on tablet. Recalculate once its dimensions are available.
  const firstHeroImage = heroSlider.querySelector('.splide__slide img');
  const refreshHeroSplide = function () {
    window.requestAnimationFrame(function () {
      heroSplide.refresh();
    });
  };

  if (firstHeroImage) {
    if (firstHeroImage.complete) {
      refreshHeroSplide();
    } else {
      firstHeroImage.addEventListener('load', refreshHeroSplide, { once: true });
    }
  }


  // ----------------------------Home tab slider---------------------------

  // ----------------------------Home tab slider END---------------------------




   //------------------------------------ Index video review Js ------------
   const videoWrappers = document.querySelectorAll('.video-wrapper');

  // Stop if no video wrappers exist
   if (!videoWrappers.length) return;

    videoWrappers.forEach(function (wrapper) {

      wrapper.addEventListener('click', function () {

        const video = this.querySelector('.video-element');
        const img = this.querySelector('.video-thumbnail');
        const btn = this.querySelector('.play-btn');

        // Stop if no video found
        if (!video) return;

        video.style.display = 'block';

        // Safe play for browsers
        const playPromise = video.play();

        if (playPromise !== undefined) {
          playPromise.catch(function () {
            // Prevent console errors
          });
        }
        if (img) {
          img.style.display = 'none';
        }

        if (btn) {
          btn.style.display = 'none';
        }

    });

  });


});
// end of document



// ------------------------------------------Index our story section js -----------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {

  /*
   * Lazy-load background image
   */
  const rightPanel = document.querySelector('.our-story-right[data-bg]');

  if (rightPanel) {

    if ('IntersectionObserver' in window) {

      const bgObserver = new IntersectionObserver(function (entries, obs) {

        entries.forEach(function (entry) {

          if (entry.isIntersecting) {

            entry.target.style.backgroundImage =
              'url(' + entry.target.dataset.bg + ')';

            obs.unobserve(entry.target);
          }

        });

      }, {
        rootMargin: '200px'
      });

      bgObserver.observe(rightPanel);

    } else {

      rightPanel.style.backgroundImage =
        'url(' + rightPanel.dataset.bg + ')';

    }
  }


  /*
   * Inline video
   */
  const playBtn = document.querySelector('.video-play-btn');
  const videoContainer = document.querySelector('.our-story-video');

  if (!playBtn || !videoContainer) return;


  function getEmbedUrl(videoUrl) {

    if (!videoUrl) return '';

    /*
     * YouTube
     */
    if (
      videoUrl.includes('youtube.com') ||
      videoUrl.includes('youtu.be')
    ) {

      let id = '';

      if (videoUrl.includes('youtu.be')) {

        id = videoUrl
          .split('youtu.be/')[1]
          ?.split('?')[0]
          ?.split('&')[0];

      } else {

        try {

          const url = new URL(videoUrl);

          id = url.searchParams.get('v');

        } catch (error) {

          console.log('Invalid YouTube URL:', error);

        }
      }

      return id
        ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0'
        : '';
    }


    /*
     * Vimeo
     */
    if (videoUrl.includes('vimeo.com')) {

      let id = '';

      try {

        const url = new URL(videoUrl);

        const parts = url.pathname.split('/').filter(Boolean);

        id = parts[parts.length - 1];

      } catch (error) {

        console.log('Invalid Vimeo URL:', error);

      }

      return id
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
        : '';
    }


    return '';
  }


  function playVideo() {

    const videoUrl = playBtn.getAttribute('data-video');

    if (!videoUrl) return;

    const embedUrl = getEmbedUrl(videoUrl);

    if (!embedUrl) return;


    /*
     * Create iframe only when user clicks play.
     */
    videoContainer.innerHTML =
      '<iframe ' +
        'src="' + embedUrl + '" ' +
        'frameborder="0" ' +
        'allow="autoplay; fullscreen; picture-in-picture; encrypted-media" ' +
        'allowfullscreen ' +
        'title="Story Video">' +
      '</iframe>';


    /*
     * Hide thumbnail and play button.
     */
    playBtn.style.display = 'none';

    const image = document.querySelector('.our-story-image');

    if (image) {
      image.style.display = 'none';
    }


    /*
     * Show video.
     */
    videoContainer.classList.add('active');
    videoContainer.setAttribute('aria-hidden', 'false');
  }


  /*
   * Click
   */
  playBtn.addEventListener('click', function (event) {

    event.preventDefault();

    playVideo();

  });


  /*
   * Keyboard accessibility
   */
  playBtn.addEventListener('keydown', function (event) {

    if (event.key === 'Enter' || event.key === ' ') {

      event.preventDefault();

      playVideo();

    }

  });

});


// -------------- End of JS index our story -----------------------


// ----------------------Home + collection page featured in brabd slider splide js-------------------------
document.addEventListener('DOMContentLoaded', function () {

  if (typeof Splide === 'undefined') {
    console.log('Splide not loaded');
    return;
  }

  const sliders = document.querySelectorAll('.featured-logo-slider');

  if (!sliders.length) {
    console.log('Slider not found');
    return;
  }

  sliders.forEach(function (slider) {

    function initFeaturedSlider() {
    if (slider.dataset.splideInitialized === 'true') return;
    slider.dataset.splideInitialized = 'true';
    new Splide(slider, {
      type: 'loop',
      perPage: 5,
      perMove: 1,
      autoplay: true,
      interval: 3000,
      arrows: false,
      pagination: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      gap: '20px',
      

      breakpoints: {
        1440: {
          perPage: 4,
        },
        1199: {
          perPage: 3,
        },
        991: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        },
      },
    }).mount();
    }

    if ('IntersectionObserver' in window) {
      const featuredObserver = new IntersectionObserver(function (entries, observer) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        initFeaturedSlider();
      }, { rootMargin: '300px 0px' });
      featuredObserver.observe(slider);
    } else {
      initFeaturedSlider();
    }

  });

});


// video js optimization js


    document.querySelectorAll('[id^="video-"]').forEach((wrapper) => {
      const btn = wrapper.querySelector('.video-play-btn');
      const thumbnail = wrapper.querySelector('.video-thumbnail');
      const embed = wrapper.querySelector('.video-embed');

      if (!btn || !embed) return;

      btn.addEventListener('click', function () {
        // hide thumbnail + button
        if (thumbnail) thumbnail.style.display = 'none';
        btn.style.display = 'none';

        // remove overlay
        wrapper.classList.add('playing');

        // show video
        embed.classList.add('active');

        // iframe load
        const iframe = embed.querySelector('iframe');
        if (iframe && iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
        }

        // uploaded video autoplay
        const video = embed.querySelector('video');
        if (video) {
          video.muted = true;
          video.play();
        }
      });
    });


    const videos = document.querySelectorAll('.lazy-video');

    const videoObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;

          const video = entry.target;
          const videoSrc = video.dataset.src;

          if (videoSrc) {
            video.src = videoSrc;
            video.load();

            // Optional: automatically play when visible
            video.play().catch(() => {});
          }

          observer.unobserve(video);
        });
      },
      {
        rootMargin: '200px 0px',
        threshold: 0
      }
    );

    videos.forEach(video => {
      videoObserver.observe(video);
    });
  

          class VideoPlayer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.videoUrl = this.dataset.video;
      this.autoplay = this.dataset.autoplay === 'true';

      this.playBtn = this.querySelector('.video-play-btn');

      if (this.playBtn) {
        this.playBtn.addEventListener('click', () => this.playVideo());
      }
    }

    getEmbedUrl(url) {
      if (!url) return '';

      // YouTube
      if (url.includes('youtube') || url.includes('youtu.be')) {
        let videoId = '';

        if (url.includes('watch?v=')) {
          videoId = url.split('watch?v=')[1].split('&')[0];
        } else if (url.includes('youtu.be')) {
          videoId = url.split('youtu.be/')[1];
        }

        return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&playsinline=1&rel=0`;
      }

      // Vimeo
      if (url.includes('vimeo')) {
        const videoId = url.split('vimeo.com/')[1];
        return `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&playsinline=1`;
      }

      return '';
    }

      playVideo() {
        const embedUrl = this.getEmbedUrl(this.videoUrl);
        const iframe = this.querySelector('.video-iframe');
        const cover = this.querySelector('.video-player-cover');

        if (iframe && embedUrl) {
          // 1. Set the source (this triggers the load)
          // IMPORTANT: Add &mute=1 for YouTube and &muted=1 for Vimeo 
          // Browsers often block autoplay if sound isn't muted!
          iframe.src = embedUrl + (embedUrl.includes('?') ? '&' : '?') + 'autoplay=1&mute=1';
          
          // 2. Show the iframe and hide the cover
          iframe.style.display = 'block';
          if (cover) cover.style.display = 'none';
        }
      }



  }

  customElements.define('video-player', VideoPlayer);
